/* Shared Google-Maps theme + status tints + mixer-truck pin (used by the Contractor Portal map). */

export const INDUSTRIAL_MAP_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#1F2126" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#8B8F97" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#141518" }] },
  { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#3A3F47" }] },
  { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#C6C8CC" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#2A2D33" }] },
  { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#26292E" }] },
  { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
  { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#353A42" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#4A3E2B" }] },
  { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#F57C00" }] },
  { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#D8B98B" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#0F1215" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#5B6067" }] },
  { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#1A1C20" }] },
  { featureType: "landscape.man_made", elementType: "geometry", stylers: [{ color: "#22252A" }] },
];

export const STATUS_TINT = {
  available: "#22C55E",
  loading: "#F97316",
  slumping: "#FBBF24",
  en_route: "#3B82F6",
  on_site: "#A855F7",
  discharging: "#A855F7",
  returning: "#0EA5E9",
  out_of_service: "#71717A",
  maintenance: "#71717A",
};

export const STATUS_LABEL = {
  available: "Available",
  loading: "Loading",
  slumping: "Slump test",
  en_route: "En route",
  on_site: "On site",
  discharging: "Discharging",
  returning: "Returning",
  out_of_service: "Out of service",
  maintenance: "Maintenance",
};

export function truckPinDataUrl(color = "#F97316", selected = false, heading = null) {
  const ring = selected
    ? `<circle cx="24" cy="24" r="22" fill="none" stroke="#FFFFFF" stroke-width="3"/>
       <circle cx="24" cy="24" r="22" fill="none" stroke="${color}" stroke-width="2" stroke-dasharray="4 3"/>`
    : "";
  const rot = Number.isFinite(Number(heading)) ? `rotate(${Number(heading)} 24 24)` : "";
  const arrow = Number.isFinite(Number(heading))
    ? `<path d="M24 3 L29 11 L19 11 Z" fill="${color}" stroke="#0A0A0B" stroke-width="1" transform="${rot}"/>`
    : "";
  const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  ${ring}
  <circle cx="24" cy="24" r="16" fill="${color}" stroke="#0A0A0B" stroke-width="2"/>
  ${arrow}
  <g fill="#0A0A0B">
    <rect x="11" y="19" width="6" height="8" rx="1"/>
    <path d="M17 27h8l3-2 2-6h-7l-2 3h-4z"/>
    <path d="M28 19c3 0 5 2 5 4l-1 4h-5l1-8z"/>
    <circle cx="15" cy="29.5" r="2.4"/><circle cx="24" cy="29.5" r="2.4"/><circle cx="31" cy="29.5" r="2.4"/>
  </g>
</svg>`.trim();
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}
